
import { throwError as observableThrowError, Observable, BehaviorSubject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
// import { FakeTrendingVideoList } from './fake-trending-video-list';
//import { FakeRecommendedVideoList } from './fake-recommended-video-list';
//import { FakeTopVideos } from './fake-top-videos';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';
import { Utility } from '../utility';
import { environment } from 'environments/environment';


@Injectable()
export class VideoListService {
    randomList;
    randomList$: BehaviorSubject<any>;
    isAdult = environment.cinema == 2;

    constructor(
        //  private httpClient: HttpClient,
        private _videoTransFormer: VideoTransFormer,
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _utility: Utility
    ) {
        // this.getRandomVideoList();
    }

    // getTrendingVideoList(): Observable<any[]> {
    //     return of(FakeTrendingVideoList);
    // }

    // getFakeRecommendedVideoList(itemSize = 8): Observable<any[]> {
    //     return of(FakeRecommendedVideoList);
    // }

    getRelatedVideos(cid, title, videoId, labels: Array<string>, isNews = false): Observable<any[]> {
        let whichIsNews = isNews || this._utility.isNews;
        let obj: any = {
            cid,
            title: encodeURIComponent(title),
            size: whichIsNews ? this.isAdult ? 9 : 15 : 10,
            set: 1,
            isNews: isNews,
            id: videoId,
            tags: labels.join(',')
        };

        if (whichIsNews) {
            obj.cinema = 3;
        }

        const apiURL = this._apiUrlHelper.urlBuilder('video-related-list', obj);
        return this._httpClientHelper
            .get(apiURL)
            .pipe(map((res) => {
                // console.log(res);
                if (!whichIsNews) {
                    return res.map(item => {
                        return this._videoTransFormer.transformFromList(item);
                    });
                }
                else {
                    return res.map(item => {
                        return this._videoTransFormer.transformFromNews(item);
                    });
                }
                // return res;
            }));
    }

    getRandomVideosByParentCid(cid): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-random-videos-by-category', { cid, size: 6, set: 1 });
        return this._httpClientHelper
            .get(apiURL)
            .pipe(map((res) => {
                return res;
            }))
        // .pipe(map((res: Response) => {
        //     // console.log(res);
        //     // return res.json().then((data)=>{
        //     //    return data.info.map(item => {
        //     //         return this._videoTransFormer.transformFromList(item);
        //     //     });
        //     // })
        // }));//.pipe(delay(200));
    }

    // getFakeTopVideos(genre): Observable<any[]> {
    //     return of(FakeTopVideos.filter(item => item.genre === genre));
    // }

    getTopVideos(categoryId): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-list',
            {
                cid: categoryId
            });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((res: any) => {
                return res.info
            }))
        // .pipe(
        // catchError((error: any) => observableThrowError('Server error:vid' + error)));
    }

    getRecentAddedVideos(cid): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-last-added', { CID: cid, PageSize: 10 });
        return this._httpClientHelper
            .get(apiURL);
    }

    getGuessYouLikeVideos(cid): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-guess-you-like', { CID: cid, PageSize: 35 });
        return this._httpClientHelper
            .get(apiURL);
    }

    getRecentlyWatchedVideos(): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-recently-watched', { size: 30 });
        return this._httpClientHelper.get(apiURL);
    }

    getRecentUpdates(cid): Observable<any> {
        // 电视剧不传参数
        let apiURL;
        if (cid) {
            apiURL = this._apiUrlHelper.urlBuilder('video-recent-updates', { cid });
        } else {
            apiURL = this._apiUrlHelper.urlBuilder('video-recent-updates', { cid: undefined });
        }
        return this._httpClientHelper
            .get(apiURL)
            .pipe(
                map((info: any) => {
                    return info;
                }));
    }

    getRecommendedVideoList(endpoint = ""): Observable<any> {
        var params = {};
        if (endpoint) {
            params = {
                set: 0,
                size: 16
            }
        }
        const apiURL = this._apiUrlHelper.urlBuilder('videos-recommanded', params, endpoint);

        return this
            ._httpClientHelper
            .getWithCache(apiURL)
            .pipe(map((info: any) => {
                return info[0];
            }))

    }

    httpGetRandomVideoList() {
        const apiURL = this._apiUrlHelper.urlBuilder('random-video-list');
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((info: any) => {
                return info;
            }))
    }

    randomVideoListService(): Observable<any> {
        return this.randomList$.asObservable();
    }

    getRankedVideos(categoryId): Observable<any[]> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-ranked-list',
            {
                cid: categoryId
            });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((info: any) => {
                return info.map(item => {
                    // console.log(item);
                    return this._videoTransFormer.transformFromRankedList(item);
                });
            }))


    }
}
